/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiConditionValueTypeFromJSON, ApiConditionValueTypeToJSON, } from './ApiConditionValueType';
import { ApiMetricFromJSON, ApiMetricToJSON, } from './ApiMetric';
import { ApiOperatorFromJSON, ApiOperatorToJSON, } from './ApiOperator';
export function ApiAlertConditionFromJSON(json) {
    return ApiAlertConditionFromJSONTyped(json, false);
}
export function ApiAlertConditionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'alertConditionGroupId': !exists(json, 'alertConditionGroupId') ? undefined : json['alertConditionGroupId'],
        'alertId': !exists(json, 'alertId') ? undefined : json['alertId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'metric': !exists(json, 'metric') ? undefined : ApiMetricFromJSON(json['metric']),
        'operator': !exists(json, 'operator') ? undefined : ApiOperatorFromJSON(json['operator']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'valueType': !exists(json, 'valueType') ? undefined : ApiConditionValueTypeFromJSON(json['valueType']),
    };
}
export function ApiAlertConditionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'alertConditionGroupId': value.alertConditionGroupId,
        'alertId': value.alertId,
        'id': value.id,
        'metric': ApiMetricToJSON(value.metric),
        'operator': ApiOperatorToJSON(value.operator),
        'projectId': value.projectId,
        'value': value.value,
        'valueType': ApiConditionValueTypeToJSON(value.valueType),
    };
}
